export default defineNuxtRouteMiddleware(async () => {
    const supabase = useSupabase()

    const user = useUser()

    if (!user.value) {
        const { data } = await supabase.auth.getUser()
        user.value = data.user
    }
})

